@use "~theme/breakpoints";
@use "~theme/typography";

@mixin speech-balloon-arrow {
  display: none;
  content: "";
  position: absolute;
  height: 28px;
  width: 28px;
  clip-path: polygon(20% 20%, 80% 80%, 0% 100%);
  transform: rotate(45deg);
  background: var(--blue-02-at-30);

  @include breakpoints.desktop {
    display: none;
  }
}

.card {
  $card-background: var(--blue-04);

  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 16px 16px;
  background-color: $card-background;
  background-image: url("~images/clipboard-clock.svg");
  background-repeat: no-repeat;
  background-position: center 24px;
  border: 1px solid var(--blue-02-at-30);
  position: relative;
  box-shadow: 0 2px 6px var(--gray-03);  

  &::before {
    @include speech-balloon-arrow;
    left: -15px;
    border-radius: 0 0 0 7px;
    background-color: var(--blue-02-at-30);
  }

  &::after {
    @include speech-balloon-arrow;
    left: -13px;
    border-radius: 0 0 0 6px;
    background-color: var(--gray-04);
  }
}

.heading {
  @include typography.heading4;
  margin-top: 64px;
  margin-bottom: 12px;
}

.description {
  text-align: center;
  margin-bottom: 28px;
}

.notice {
  @include typography.body-semibold;
  color: var(--blue-01);
  margin-bottom: 16px;
  margin-top: 40px;
}

.button {
  width: 100%;
}
